import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import styles from './DatePreview.scss';

const DatePreview = ({
    defaultValue,
    onChange,
    isDisabled,
    placeholder,
    ...props
}) => {
    
    const date = defaultValue ? moment(defaultValue).toDate() : null;
    const [value, setValue] = useState(date);

    const handleChange = value => {
        const formattedValue = moment(value).format('YYYY-MM-DD');
        onChange(formattedValue);
        setValue(value);
    };

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
                { ...props }
                autoOk
                value={value}
                variant='inline'
                format='MMM dd, yyyy'
                className={styles.textField}
                placeholder={placeholder}
                onChange={handleChange}
                disabled={isDisabled}
            />
        </MuiPickersUtilsProvider>
    );
};

DatePreview.propTypes = {
    defaultValue: PropTypes.string,
    onChange: PropTypes.func,
    isDisabled: PropTypes.bool,
    placeholder: PropTypes.string
};

DatePreview.defaultProps = {
    onChange: () => {},
    isDisabled: false,
    placeholder: 'Pick a date'
};

export default DatePreview;
